import * as React from 'react';
import { Button } from 'antd';
import { ExternalLink } from 'lucide-react';
import { getLangKey } from 'models/Language';
import { onboardingCreateExampleTask } from 'api/ProjectApi';
import styles from './index.module.css';
import cx from 'classnames';

import track, { ONBOARDING_USE_EXAMPLE_DATA } from 'utils/analytics';

import * as translations from './strings';

type Props = {
  projectUrl: string;
  projectId: number;
  openProject?: (url: string, mode: string) => void;
  experiments: string[];
};

const TryBugHerd: React.FC<Props> = ({
  projectUrl,
  projectId,
  openProject = window.open,
  experiments
}) => {
  const strings = translations[getLangKey()];

  return (
    <div className={cx(styles.tryOuter, styles.stepContainer)}>
      <div className={styles.tryInner}>
        <div>
          {strings.tryBugHerdDescription}{' '}
          <b>{strings.tryBugHerdDescription2}</b>
        </div>
        <Button
          type="primary"
          onClick={() => {
            openProject(projectUrl, '_blank');
          }}
          className={styles.visitWebsiteButton}
        >
          <i className="anticon">
            <ExternalLink size={14} />
          </i>
          {strings.visitWebsite}
        </Button>
        {experiments.includes('onboarding_v4_skip_task_create') && (
          <a
            type="link"
            onClick={() => {
              track(ONBOARDING_USE_EXAMPLE_DATA);
              onboardingCreateExampleTask(projectId);
            }}
          >
            Or, see some example feedback we've prepared earlier.
          </a>
        )}
      </div>
    </div>
  );
};

export default TryBugHerd;
